import {
  ERRORS,
  IRotaManagementRotaUpdatePropsData,
  IRotaManagementShiftListData,
  IRotaManagementShiftTimings,
} from "@/api_framework/api_modals/Rota";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu/index";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { useRotaDeleteAPI } from "@/app/hooks/api_hooks/Rota/useRotaDeleteAPI";
import { useRotaErrorListAPI } from "@/app/hooks/api_hooks/Rota/useRotaErrorListAPI";
import { useRotaShiftCreateAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftCreateAPI";
import { useRotaShiftFilterAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftFilterAPI";
import { useRotaShiftNameAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftNameAPI";
import { useRotaUpdateAPI } from "@/app/hooks/api_hooks/Rota/useRotaUpdateAPI";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useUtils } from "@/app/hooks/useUtils";
import { IRotaState } from "@/app_redux/reducers/slices/auth/rota_slice";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import ShiftBreakComponent from "../../AddNewShiftComponent/ShiftBreakComponent";
import { IRotaAddModalProps } from "../../interface";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useRotaUpdateImpactAPI } from "@/app/hooks/api_hooks/Rota/useRotaUpdationWarnAPI";


export interface IBookingCommentsFormFields {
  shift: string;
  date: string;
  startTimeHour: string;
  startTimeMinute: string;
  endTimeHour: string;
  endTimeMinute: string;
}
export interface IDateRangeInterface {
  id?: string;
  title?: string;
}
const ShiftEditDeleteModalComponent: React.FC<IRotaAddModalProps> = (props) => {
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [flage, setFlage] = useState(false);
  const [deleteRota, setDeleteRota] = useState(false);
  const [isWeekOff, setIsWeekOff] = useState(false);
  const [addHockShift, setAddHockShift] = useState(false);
  const [editShift, setEditShift] = useState(false);
  const [shiftDetails, setShiftDetails] = useState(true);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [modifiedArray, setModifiedArray] = useState([]);
  const [selectedShelDate, setSelectedShelDate] = useState<string | null>(null);
  const [shellDisable, setShellDisable] = useState(false);
  const [calculatedStartTime, setCalculatedStartTime] = useState([]);
  const [bookingImpactCount, setBookingImpactCount] = useState<number | null>(null);
  const [updateImpactCount, setUpdateImpactCount] = useState<number | null>(null);
  


  const { truncateString } = useUtils();
  const isProcessing = Boolean(props.shellDetails?.is_processing);
  const processingLabelClass = props.shellDetails?.is_week_off ? "text-[#606060]" : "text-[#93550D]";

  const { execute: standardShiftCreate, shiftId, setShiftId } = useRotaShiftCreateAPI();

  const deleteRotaAPI = useRotaDeleteAPI();
  const fetchErrorListAPI = useRotaErrorListAPI();
  const fetchCliniRotaDetails = useRotaShiftFilterAPI();
  const fetchRotaShiftNameAPI = useRotaShiftNameAPI();
  const { execute: warnRotaUpdate } = useRotaUpdateImpactAPI();


  const { execute: updateRotaAPI, AppError, setAppError } = useRotaUpdateAPI();
  const [creationErrorMessage, setCreationErrorMessage] = useState<string | null>("");
  const { execute: logAPI } = useClickLogAPI();

  const [shiftTimes, setShiftTimes] = useState([]);

  const arrayConstants = useArrayConstants();

  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");
  const { routeState } = useRouteInfo(routeId);
  const { rotaShiftName, RotaFilter, rotaerrorIds } = routeState.state as IRotaState;

  const startTimeItem = arrayConstants.overBookingStartTimeItems as ISelectMenuItemData[];

  const startTimeMinuteItem = arrayConstants.overBookingStartTimeMinuteItems as ISelectMenuItemData[];

  const shiftItems = useSelectMenuReducer(rotaShiftName, "shift_data_transformed", "id");
  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);

  // const handelReapetDates = () => {
  //   const selectedDate = props?.dateRange?.find(
  //     (d: any) => d.id === props?.shellDetails?.rota_date,
  //   ) as IDateRangeInterface;

  //   const clickDate = selectedDate?.id;
  //   setSelectedShelDate(clickDate);

  //   const modified = [];
  //   for (let i = 1; i <= 6; i++) {
  //     const nextDay = new Date(clickDate);
  //     nextDay.setDate(nextDay.getDate() + i);
  //     const formattedDate = `${nextDay.toLocaleDateString("en-US", { weekday: "short" })}-${nextDay.getDate()}-${nextDay.getFullYear()}`;
  //     modified.push({
  //       title: formattedDate,
  //       id: `${nextDay.getFullYear()}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay.getDate().toString().padStart(2, "0")}`,
  //     });
  //   }

  //   setModifiedArray(modified);
  //   fetchRotaShiftNameAPI();
  // };

  const handelReapetDates = () => {
    const selectedDate = props?.dateRange?.find(
      (d: any) => d.id === props?.shellDetails?.rota_date,
    ) as IDateRangeInterface;

    const clickDate = selectedDate?.id;
    setSelectedShelDate(clickDate);

    const generateDateArray = (days) => {
      const modified = [];
      for (let i = 1; i <= days; i++) {
        const nextDay = new Date(clickDate);
        nextDay.setDate(nextDay.getDate() + i);

        const formattedDate = `${nextDay.getDate().toString().padStart(2, "0")}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay.getFullYear()}`;
        modified.push({
          title: formattedDate,
          id: `${nextDay.getFullYear()}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay.getDate().toString().padStart(2, "0")}`,
        });
      }
      return modified;
    };

    const sevenDaysArray = generateDateArray(6);
    const fifteenDaysArray = generateDateArray(14);
    const thirtyDaysArray = generateDateArray(29);

    const endDates = {
      sevenDays: sevenDaysArray[sevenDaysArray.length - 1].title,
      fifteenDays: fifteenDaysArray[fifteenDaysArray.length - 1].title,
      thirtyDays: thirtyDaysArray[thirtyDaysArray.length - 1].title,
    };

    const dateRanges = [
      { label: `7 Days (till ${endDates.sevenDays})`, data: sevenDaysArray },
      { label: `15 Days (till ${endDates.fifteenDays})`, data: fifteenDaysArray },
      { label: `30 Days (till ${endDates.thirtyDays})`, data: thirtyDaysArray },
    ];

    // Setting the modified array with all date ranges
    setModifiedArray(dateRanges);

    fetchRotaShiftNameAPI();
  };

  const dateRangeItems = useSelectMenuReducer(modifiedArray, "label", "data");

  const formHook = useForm<IBookingCommentsFormFields>({
    mode: "onChange",
    defaultValues: {},
  });

  const handleCheckboxChange = () => {
    setIsWeekOff(!isWeekOff);
    setUpdateImpactCount(null);
  };

  const handleAddTime = () => {
    setFlage(true);
    setUpdateImpactCount(null);
    const form_data = formHook.getValues();
    setShiftTimes((prevTimes) => [
      ...prevTimes,
      {
        startTimeHour: form_data.startTimeHour,
        startTimeMinute: form_data.startTimeMinute,
        endTimeHour: form_data.endTimeHour,
        endTimeMinute: form_data.endTimeMinute,
      },
    ]);

    formHook.setValue("startTimeHour", form_data.endTimeHour);
    formHook.setValue("startTimeMinute", form_data.endTimeMinute);
    formHook.setValue("endTimeHour", "");
    formHook.setValue("endTimeMinute", "");
  };

  const handleRemoveTime = (index) => {
    setShiftTimes((prevTimes) => prevTimes.filter((_, i) => i !== index));

    formHook.setValue("startTimeHour", "");
    formHook.setValue("startTimeMinute", "");
    setCalculatedStartTime(startTimeItem);
    setUpdateImpactCount(null);
  };

  useEffect(() => {
    const form_data = formHook.getValues();
    if (form_data?.startTimeHour && flage) {
      const startTime = parseInt(form_data?.startTimeHour); // Convert to integer
      const filteredData = startTimeItem?.filter((item) => parseInt(item.id) >= startTime);
      setCalculatedStartTime(filteredData);
    } else {
      const filteredData = startTimeItem?.filter((item) => parseInt(item.id) >= 0);
      setCalculatedStartTime(filteredData);
    }
  }, [formHook.watch("endTimeMinute")]);

  useEffect(() => {
    if (!addHockShift || isWeekOff) {
      return;
    }

    const timings = getAdhocTimingsForImpact();
    if (timings.length === 0) {
      setUpdateImpactCount(null);
      return;
    }

    const hasInvalidTiming = timings.some((timing) => !timing.start_time || !timing.end_time);
    if (hasInvalidTiming) {
      setUpdateImpactCount(null);
      return;
    }

    fetchUpdateImpact(timings);
  }, [
    addHockShift,
    isWeekOff,
    shiftTimes,
    formHook.watch("startTimeHour"),
    formHook.watch("startTimeMinute"),
    formHook.watch("endTimeHour"),
    formHook.watch("endTimeMinute"),
  ]);

  const createShiftAdHok = () => {
    const form_data = formHook.getValues();

    let constructedBody: IRotaManagementShiftListData = {
      shift_name: "Adhoc Shift",
      shift_timings: null,
      shift_status: true,
      shift_type: "adhoc",
    };
    if (flage) {
      constructedBody = {
        ...constructedBody,
        shift_timings: [
          ...shiftTimes.map(({ startTimeHour, startTimeMinute, endTimeHour, endTimeMinute }) => {
            return {
              start_time: `${startTimeHour}:${startTimeMinute}`,
              end_time: `${endTimeHour}:${endTimeMinute}`,
            };
          }),
          // Append additional object if form_data.endTimeHour is available
          form_data.endTimeHour &&
          (() => {
            return {
              start_time: `${form_data.startTimeHour}:${form_data.startTimeMinute}`,
              end_time: `${form_data.endTimeHour}:${form_data.endTimeMinute}`,
            };
          })(),
        ].filter(Boolean), // Remove any potential undefined values
      };
    } else {
      constructedBody = {
        ...constructedBody,
        shift_timings: [
          {
            start_time: `${form_data.startTimeHour}:${form_data.startTimeMinute}`,
            end_time: `${form_data.endTimeHour}:${form_data.endTimeMinute}`,
          },
        ],
      };
    }

    standardShiftCreate(constructedBody);
  };

  useEffect(() => {
    if (shiftId) {
      const form_data = formHook.getValues();
      const dates = form_data.date;
      const rotaDateSet = new Set(dates ? [...dates, selectedShelDate] : [selectedShelDate]);
      const rotaDate = Array?.from(rotaDateSet);

      const constructedBody: IRotaManagementRotaUpdatePropsData = {
        clinic_id: props?.clinicId?.clinic_id,
        staff_id: props?.stafDetails?.staff_id,
        shift_id: shiftId,
        rota_dates: rotaDate,
        is_week_off: isWeekOff ? true : false,
      };

      updateRotaAPI(constructedBody, props.shellDetails?.id).then(async (response) => {
        if (response.status) {
          await fetchCliniRotaDetails(RotaFilter);
          setOpen(false);
          setAddHockShift(false);
          setShiftId(null);
        } else {
          setOpen(true);
        }
      });
    }
  }, [shiftId]);

  const handelUpdateRota = () => {
    if (addHockShift) {
      createShiftAdHok();
    } else {
      const form_data = formHook.getValues();
      const dates = Array.isArray(form_data.date) ? form_data.date.map((item) => item.id) : []; // Fallback to an empty array if form_data.date is not an array

      const rotaDateSet = new Set(dates ? [...dates, selectedShelDate] : [selectedShelDate]);
      const rotaDate = Array?.from(rotaDateSet);

      const constructedBody: IRotaManagementRotaUpdatePropsData = {
        clinic_id: props?.clinicId?.clinic_id,
        staff_id: props?.stafDetails?.staff_id,
        shift_id: isWeekOff ? "65b8a8f11c6793646f847e9b" : form_data?.shift,
        rota_dates: rotaDate,
        is_week_off: isWeekOff ? true : false,
      };

      updateRotaAPI(constructedBody, props.shellDetails?.id).then(async (response) => {
        if (response.status) {
          const logBody: IClickLogBody = {
            event_type: "ROTA_UPDATE",
            clinic_id: props?.clinicId?.clinic_id,
            staff_id: props?.stafDetails?.staff_id,
            shift_id: isWeekOff ? "65b8a8f11c6793646f847e9b" : form_data?.shift,
            vms_user_id: userLogInfo,
            scr_id: "ROTA",
            timestamp: Date.now(),
          };
          logAPI(logBody);
          setOpen(false);
          await fetchCliniRotaDetails(RotaFilter);
        } else {
          setOpen(true);
        }
      });
    }
  };

  const shiftDetailsComponent = () => {
    return (
      <div className="flex flex-col gap-7 mt-4">
        <div className="flex items-center gap-6">
          <h1 className="w-1/5 font-normal text-xs">Name</h1>
          <div className="w-8/12 font-medium text-xs">{props.stafDetails.staff_name}</div>
        </div>
        <div className="flex items-center gap-6">
          <h1 className="w-1/5 font-normal text-xs">Date</h1>
          <div className="w-8/12 font-medium text-xs">{props?.shellDetails?.rota_date}</div>
        </div>
        <div className="flex items-center gap-6">
          <h1 className="w-1/5 font-normal text-xs">Shift Name</h1>
          <div className="w-8/12 font-medium text-xs">
            <p>{props.shellDetails?.shift_data?.shift_data_transformed} </p>
          </div>
        </div>
      </div>
    );
  };

  const handelDeleteRota = (id: string) => {
    deleteRotaAPI(id).then(() => {
      const logBody: IClickLogBody = {
        event_type: "ROTA_DELETE",
        rota_id: id,
        staff_id: props?.stafDetails?.staff_id,
        clinic_id: props?.stafDetails?.clinic_id,
        shift_id: props?.stafDetails?.shift_id,
        vms_user_id: userLogInfo,
        scr_id: "ROTA",
        timestamp: Date.now(),
      };
      logAPI(logBody);
      fetchCliniRotaDetails(RotaFilter);
    });

    setOpen(false);
    setEditShift(false);
    setDeleteRota(false);
    setShiftDetails(true);
    setDeleteConfirmation(false);
    setBookingImpactCount(null);
  };

  const convertTimeFormat = (time: string) => {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));

    return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true });
  };

  const ShowTimings = (shiftTimes: IRotaManagementShiftTimings[]) => {
    return shiftTimes
      ?.map(({ start_time, end_time }) => {
        const formattedStartTime = convertTimeFormat(start_time);
        const formattedEndTime = convertTimeFormat(end_time);

        return `${formattedStartTime} to ${formattedEndTime}`;
      })
      ?.join(", ");
  };

  const fetchUpdateImpact = async (shiftTimings: IRotaManagementShiftTimings[]) => {
    const rotaId = props.shellDetails?.id;
    const clinicId = props?.clinicId?.clinic_id;
    const staffId = props?.stafDetails?.staff_id;
    const rotaDate = props?.shellDetails?.rota_date;

    if (!rotaId || !clinicId || !staffId || !rotaDate) {
      setUpdateImpactCount(null);
      return;
    }

    const response = await warnRotaUpdate({
      clinic_id: clinicId,
      staff_id: staffId,
      rota_date: rotaDate,
      rota_id: rotaId,
      shift_timings: (shiftTimings ?? []).map(({ start_time, end_time }) => ({
        start_time,
        end_time,
      })),
    });

    if (response?.status) {
      setUpdateImpactCount(response?.data?.booking_count ?? 0);
    } else {
      setUpdateImpactCount(null);
    }
  };

  const getAdhocTimingsForImpact = () => {
    const form_data = formHook.getValues();
    const timings: IRotaManagementShiftTimings[] = shiftTimes.map(
      ({ startTimeHour, startTimeMinute, endTimeHour, endTimeMinute }) => ({
        start_time: `${startTimeHour}:${startTimeMinute}`,
        end_time: `${endTimeHour}:${endTimeMinute}`,
      }),
    );

    const hasCurrentStart = Boolean(form_data?.startTimeHour && form_data?.startTimeMinute);
    const hasCurrentEnd = Boolean(form_data?.endTimeHour && form_data?.endTimeMinute);

    if (hasCurrentStart && hasCurrentEnd) {
      timings.push({
        start_time: `${form_data.startTimeHour}:${form_data.startTimeMinute}`,
        end_time: `${form_data.endTimeHour}:${form_data.endTimeMinute}`,
      });
    }

    return timings;
  };

  const callBack = () => {
    setAddHockShift(true);
    setUpdateImpactCount(null);
  };

  const handelShiftEdit = () => {
    setEditShift(true);
    setShiftDetails(false);
    setDeleteConfirmation(false);
    setUpdateImpactCount(null);

    formHook.setValue("shift", props.shellDetails?.shift_id);

    if (props.shellDetails?.is_week_off) {
      setIsWeekOff(true);
    } else {
      setIsWeekOff(false);
    }
  };

  const handelDeleteActive = async () => {
    const rotaId = props.shellDetails?.id;

    const response = await warnRotaUpdate({
      clinic_id: props?.clinicId?.clinic_id,
      staff_id: props?.stafDetails?.staff_id,
      rota_date: props?.shellDetails?.rota_date,
      rota_id: rotaId,
    });

    if (response?.status) {
      setBookingImpactCount(response?.data?.booking_count ?? 0);
      setDeleteRota(true);
      setShiftDetails(false);
      setDeleteConfirmation(true);
    }
  };

  useEffect(() => {
    if (AppError === null) {
      setOpen(false);
      setEditShift(false);
      setShiftDetails(true);
      setDeleteConfirmation(false);
      setUpdateImpactCount(null);
    } else {
      setOpen(true);
      setCreationErrorMessage(AppError);
    }
  }, [AppError]);

  const handelErrorList = () => {
    const errorId = rotaerrorIds.data.error_id as string;

    const constructedBody: ERRORS = {
      error_id: errorId,
    };
    fetchErrorListAPI(constructedBody);
    navigate(`/app/rota/rota-error`);
  };

  const handelPermisionButton = () => {
    const form_data = formHook.getValues();
    if (form_data.shift || isWeekOff) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    handelPermisionButton();
    if (!isWeekOff) {
      formHook.setValue("shift", null);
    }
  }, [isWeekOff]);

  const handelPermisionButtonAdhok = () => {
    const form_data = formHook.getValues();
    if (form_data.startTimeHour && form_data.startTimeMinute && form_data.endTimeHour && form_data.endTimeMinute) {
      return false;
    } else if (shiftTimes?.length >= 1) {
      return false;
    } else {
      return true;
    }
  };
  const handelPermisionButtonAdhokAdd = () => {
    const form_data = formHook.getValues();
    if (form_data.startTimeHour && form_data.startTimeMinute && form_data.endTimeHour && form_data.endTimeMinute) {
      return false;
    } else {
      return true;
    }
  };

  const handelOpenModal = () => {
    if (isProcessing) {
      setShellDisable(true);
      return;
    }

    const selectedDate = props?.dateRange?.find(
      (d: any) => d.id === props?.shellDetails?.rota_date,
    ) as IDateRangeInterface;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedShellDate = selectedDate?.id;
    const providedDate = new Date(selectedShellDate);

    if (providedDate > today) {
      setOpen(true);
      handelReapetDates();
    }
  };

  const handelOpenHoverModal = () => {
    if (isProcessing) {
      setShellDisable(true);
      return;
    }

    const selectedDate = props?.dateRange?.find(
      (d: any) => d.id === props?.shellDetails?.rota_date,
    ) as IDateRangeInterface;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedShellDate = selectedDate?.id;
    const providedDate = new Date(selectedShellDate);

    if (providedDate > today) {
      setShellDisable(false);
    } else {
      setShellDisable(true);
    }
  };

  useEffect(() => {
    if (shiftTimes?.length === 0) {
      setFlage(false);
    }
  }, [shiftTimes]);

  return (
    <div>
      <div className="border-slate-100 border h-16">
        <div
          onClick={() => {
            handelOpenModal();
          }}
          className={`${shellDisable || isProcessing ? "cursor-not-allowed" : "cursor-pointer"} ${props.shellDetails?.is_week_off ? "bg-[#EFEFEF] border-[#606060] " : "bg-[#FFF1E1] border-[#93550D] "}   text-left h-[59px]  rounded-md mr-1 p-1  border-l-2 ${isProcessing ? "opacity-60" : ""} relative`}
          onMouseEnter={() => {
            handelOpenHoverModal();
          }}
        >
          {isProcessing && (
            <span className={`absolute top-1 left-1 text-[10px] font-bold uppercase ${processingLabelClass}`}>
              Processing
            </span>
          )}
          <p
            className={` ${props.shellDetails?.is_week_off ? "text-[#606060]" : "text-[#93550D]"} text-left flex flex-col capitalize ${isProcessing ? "mt-4" : ""}`}
          >
            {props.shellDetails?.shift_data?.shift_timings?.length > 2 ? (
              <span
                className="font-normal text-[11px]"
                data-tooltip-id="shiftTimengs"
                data-tooltip-content={ShowTimings(props.shellDetails?.shift_data?.shift_timings)}
              >
                {truncateString(ShowTimings(props.shellDetails?.shift_data?.shift_timings), 40)}
              </span>
            ) : (
              <span className="font-normal text-[11px]">
                {ShowTimings(props.shellDetails?.shift_data?.shift_timings)}
              </span>
            )}
            <span className="font-semibold text-[11px]"> {props.shellDetails?.shift_data?.shift_name}</span>
          </p>
        </div>
      </div>
      <Tooltip id="shiftTimengs" />

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="z-50 fixed inset-0 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(true)}
        >
          <div className="sm:block flex justify-center items-end px-4 sm:p-0 pt-4 pb-20 min-h-screen text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <span className="sm:inline-block hidden sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white shadow-xl sm:my-8 rounded-lg sm:w-full sm:max-w-[45rem] text-left transform transition-all overflow-visible sm:align-middle">
                <div className="bg-white px-4 sm:p-6 pt-5 pb-4 sm:pb-4">
                  <h3 className="flex justify-between mb-1 font-medium text-[#000] text-sm">
                    <span className="flex items-center gap-3 text-xs">
                      {" "}
                      Schedule Details{" "}
                      {!deleteConfirmation && !editShift && (
                        <>
                          <span onClick={() => handelShiftEdit()} className="cursor-pointer">
                            <PencilSquareIcon className="w-4 h-4" />
                          </span>
                          <span className="text-red-500 cursor-pointer">
                            <TrashIcon className="w-4 h-4" onClick={() => handelDeleteActive()} />
                          </span>
                        </>
                      )}
                    </span>

                    <span className="ml-6 cursor-pointer" onClick={() => setOpen(false)}>
                      {!deleteConfirmation && !editShift && <XMarkIcon className="w-4 h-4" />}
                    </span>
                  </h3>

                  <hr className="mt-3" />
                  {shiftDetails && <div> {shiftDetailsComponent()}</div>}
                  {deleteConfirmation && (
                    <h3 className="mt-3 text-sm">

                      {bookingImpactCount > 0 && (
                        <>
                          Deleting this ROTA will impact{" "}
                          <span className="font-semibold text-red-600">
                            {bookingImpactCount}
                          </span>{" "}Bookings
                          <br />
                        </>
                      )}

                      Are you sure you want to proceed ahead with rota deletion?
                    </h3>
                  )}

                  {deleteRota && (
                    <div>
                      <div className="flex justify-end gap-4 mt-6">
                        <button
                          type="button"
                          onClick={() => {
                            setOpen(false);
                            setEditShift(false);
                            setDeleteRota(false);

                            setShiftDetails(true);
                            setDeleteConfirmation(false);
                          }}
                          className="inline-flex justify-center bg-gray-500 hover-bg-gray-50 mt-3 sm:mt-0 px-6 py-2 rounded-md ring-gray-300 ring-inset w-full sm:w-auto font-semibold text-white text-xs"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={() => handelDeleteRota(props.shellDetails?.id)}
                          className="inline-flex justify-center bg-[#E11D48] hover-bg-gray-50 mt-3 sm:mt-0 px-6 py-2 rounded-md ring-gray-300 ring-inset w-full sm:w-auto font-semibold text-white text-xs"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}

                  {editShift && (
                    <div>
                      <div className="flex gap-2 my-5">
                        <input
                          type="checkbox"
                          checked={isWeekOff}
                          onChange={handleCheckboxChange}
                          className="border-gray-300 rounded-sm focus:ring-0 w-4 h-4 text-black"
                        />
                        <p>Week Off</p>
                      </div>
                      <div className="flex flex-col gap-7 mt-4">
                        <div className="flex items-center gap-6">
                          <h1 className="w-1/5 font-normal text-xs">Name</h1>
                          <div className="w-8/12 font-medium text-xs">{props?.stafDetails?.staff_name}</div>
                        </div>
                        <div className="flex items-center gap-6">
                          <h1 className="w-1/5 font-normal text-xs">Clinic</h1>
                          <div className="w-8/12 font-medium text-xs">{props?.clinicId?.clinic_name}</div>
                        </div>
                        {!isWeekOff && (
                          <div>
                            <div className="flex items-center gap-6">
                              <h1 className="w-1/5 font-normal text-xs">Shift Name</h1>
                              <div className="flex flex-col gap-4 w-8/12 font-medium text-xs">
                                {!addHockShift && (
                                  <NonSearchableSelectMenu
                                    errorMessages={[{ message: "shift is required", type: "required" }]}
                                    onSelectItem={(item) => {
                                      if (item) {
                                        formHook.setValue("shift", item.id);
                                        setAddHockShift(false);
                                        const selectedShift = rotaShiftName?.find((shift) => shift.id === item.id);
                                        if (selectedShift?.shift_timings?.length) {
                                          fetchUpdateImpact(selectedShift.shift_timings);
                                        } else {
                                          setUpdateImpactCount(null);
                                        }
                                      }
                                    }}
                                    fieldError={formHook.formState.errors.shift}
                                    register={formHook.register("shift", { required: true })}
                                    selectItems={shiftItems}
                                    placeholder="Select Shift"
                                    showTooltips={false}
                                    showTypedErrors={false}
                                    showDropdownIcon={true}
                                    addAction={{ title: "+ Create Adhoc Shift", callBack }}
                                    defaultSelected={shiftItems?.filter((oc) => oc.id === formHook.watch("shift"))[0]}
                                    listBoxClassName="w-full"
                                    className="text-gray-800"
                                    containerClassName="w-full"
                                  />
                                )}
                                {addHockShift && (
                                  <div className="flex flex-col">
                                    <div className="grid grid-cols-2">
                                      <p className="font-medium">Start Time</p>
                                      <p className="font-medium">End Time</p>
                                    </div>

                                    {shiftTimes.length > 0 && (
                                      <ShiftBreakComponent
                                        shiftTimes={shiftTimes}
                                        handleRemoveTime={handleRemoveTime}
                                      />
                                    )}
                                    <div className="flex gap-3 item-center">
                                      <div className="items-center gap-5 grid grid-cols-2">
                                        <div className="items-center gap-3 grid grid-cols-2 mt-2">
                                          <NonSearchableSelectMenu
                                            errorMessages={[{ message: "shift is required", type: "required" }]}
                                            onSelectItem={(item) => {
                                              if (item) {
                                                formHook.setValue("startTimeHour", item.title);
                                              }
                                            }}
                                            fieldError={formHook.formState.errors.shift}
                                            register={formHook.register("startTimeHour", { required: true })}
                                            selectItems={calculatedStartTime}
                                            placeholder="HH"
                                            showTooltips={false}
                                            showTypedErrors={false}
                                            showDropdownIcon={true}
                                            defaultSelected={
                                              calculatedStartTime?.filter(
                                                (oc) => oc.title === formHook.watch("startTimeHour"),
                                              )[0]
                                            }
                                            listBoxClassName="w-full"
                                            className="text-gray-800"
                                            containerClassName="w-full"
                                          />
                                          <NonSearchableSelectMenu
                                            errorMessages={[{ message: "shift is required", type: "required" }]}
                                            onSelectItem={(item) => {
                                              if (item) {
                                                formHook.setValue("startTimeMinute", item.title);
                                              }
                                            }}
                                            fieldError={formHook.formState.errors.shift}
                                            register={formHook.register("startTimeMinute", { required: true })}
                                            selectItems={startTimeMinuteItem}
                                            placeholder="MM"
                                            showTooltips={false}
                                            showTypedErrors={false}
                                            showDropdownIcon={true}
                                            defaultSelected={
                                              startTimeMinuteItem?.filter(
                                                (oc) => oc.title === formHook.watch("startTimeMinute"),
                                              )[0]
                                            }
                                            listBoxClassName="w-full"
                                            className="text-gray-800"
                                            containerClassName="w-full"
                                          />
                                        </div>

                                        <div className="items-center gap-3 grid grid-cols-2 mt-2">
                                          <NonSearchableSelectMenu
                                            errorMessages={[{ message: "shift is required", type: "required" }]}
                                            onSelectItem={(item) => {
                                              if (item) {
                                                formHook.setValue("endTimeHour", item.title);
                                              }
                                            }}
                                            fieldError={formHook.formState.errors.shift}
                                            register={formHook.register("endTimeHour", { required: true })}
                                            selectItems={startTimeItem}
                                            placeholder="HH"
                                            showTooltips={false}
                                            showTypedErrors={false}
                                            showDropdownIcon={true}
                                            defaultSelected={
                                              startTimeItem?.filter(
                                                (oc) => oc.title === formHook.watch("endTimeHour"),
                                              )[0]
                                            }
                                            listBoxClassName="w-full"
                                            className="text-gray-800"
                                            containerClassName="w-full"
                                          />
                                          <NonSearchableSelectMenu
                                            errorMessages={[{ message: "shift is required", type: "required" }]}
                                            onSelectItem={(item) => {
                                              if (item) {
                                                formHook.setValue("endTimeMinute", item.title);
                                              }
                                            }}
                                            fieldError={formHook.formState.errors.shift}
                                            register={formHook.register("endTimeMinute", { required: true })}
                                            selectItems={startTimeMinuteItem}
                                            placeholder="MM"
                                            showTooltips={false}
                                            showTypedErrors={false}
                                            showDropdownIcon={true}
                                            defaultSelected={
                                              startTimeMinuteItem?.filter(
                                                (oc) => oc.title === formHook.watch("endTimeMinute"),
                                              )[0]
                                            }
                                            listBoxClassName="w-full"
                                            className="text-gray-800"
                                            containerClassName="w-full"
                                          />
                                        </div>
                                      </div>
                                      <button
                                        disabled={handelPermisionButtonAdhokAdd()}
                                        className={`${!handelPermisionButtonAdhokAdd() ? "text-[#0068FF]" : "text-greay-500"} text-lg cursor-pointer mt-2`}
                                        onClick={handleAddTime}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                )}
                                {updateImpactCount !== null && updateImpactCount > 0 && (
                                  <p className="text-xs text-[#7A1D1D]">
                                    Updating this ROTA will impact{" "}
                                    <span className="font-semibold text-red-600">{updateImpactCount}</span> Bookings
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {!isWeekOff && (
                          <div className="flex items-center gap-6">
                            <h1 className="w-1/5 text-xs">Repeats</h1>
                            <div className="w-8/12">
                              <NonSearchableSelectMenu
                                errorMessages={[{ message: "shift is required", type: "required" }]}
                                onSelectItem={(item) => {
                                  if (item) {
                                    formHook.setValue("date", item.id);
                                  }
                                }}
                                fieldError={formHook.formState.errors.shift}
                                register={formHook.register("date", { required: true })}
                                selectItems={dateRangeItems ?? []}
                                placeholder="Select Days"
                                showTooltips={false}
                                showDropdownIcon={true}
                                showTypedErrors={false}
                                defaultSelected={dateRangeItems?.filter((oc) => oc.id === formHook.watch("date"))[0]}
                                listBoxClassName="w-full"
                                className="text-gray-800"
                                containerClassName="w-full"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      {creationErrorMessage && (
                        <p className="mt-5 text-red-500">
                          {creationErrorMessage}{" "}
                          <span
                            className="ml-4 font-medium text-blue-500 underline cursor-pointer"
                            onClick={handelErrorList}
                          >
                            View Error
                          </span>
                        </p>
                      )}

                      <div className="flex justify-end gap-4 mt-6">
                        <button
                          type="button"
                          onClick={() => {
                            setEditShift(false);
                            setShiftDetails(true);

                            setAddHockShift(false);
                            setOpen(false);
                            setAppError(null);
                            setUpdateImpactCount(null);
                          }}
                          className="inline-flex justify-center bg-gray-500 hover-bg-gray-50 mt-3 sm:mt-0 px-6 py-2 rounded-md ring-gray-300 ring-inset w-full sm:w-auto font-semibold text-white text-xs"
                        >
                          Cancel
                        </button>
                        {addHockShift ? (
                          <button
                            type="button"
                            onClick={() => handelUpdateRota()}
                            className={`rounded-md  ${!handelPermisionButtonAdhok() ? "bg-[#193A6A]" : "bg-gray-400"} bg-[#193A6A]
                      rounded-md text-xs font-semibold text-white px-4`}
                            disabled={handelPermisionButtonAdhok()}
                          >
                            Update
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handelUpdateRota()}
                            className={`rounded-md  ${!handelPermisionButton() ? "bg-[#193A6A]" : "bg-gray-400"} bg-[#193A6A]
                      rounded-md text-xs font-semibold text-white px-4`}
                            disabled={handelPermisionButton()}
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ShiftEditDeleteModalComponent;